import React, { Component } from 'react';
import classNames from 'classnames';
import { Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

export default class LevelView extends Component {
  render() {
    const titleClass = classNames({ 'parsley-error-label': this.props.meta.touched && this.props.meta.error }, 'control-label')
    const { input, isRequired } = this.props;
    return (
      <div style={styles.container}>
        <label style={{width: '60px'}} className={titleClass}><Translate value={'Level'} />{isRequired && <span className="asteriksReq">*</span>}</label>
        <div style={styles.booleanInput}>
            <label style={styles.section}>
              <Input {...input} type="radio" value="0" checked={input.value === 0 || input.value === '0' } /><Translate value="Lv0" />
            </label>
            <label style={styles.section}>
              <Input {...input} type="radio" value="1" checked={input.value === 1 || input.value === '1' } /><Translate value="Lv1" />
            </label>
            <label style={styles.section}>
              <Input {...input} type="radio" value="2" checked={input.value === 2 || input.value === '2' } /><Translate value="Lv2" />
            </label>
            <label style={styles.section}>
              <Input {...input} type="radio" value="3" checked={input.value === 3 || input.value === '3' } /><Translate value="Lv3" />
            </label>
            <label style={styles.section}>
              <Input {...input} type="radio" value="4" checked={input.value === 4 || input.value === '4' } /><Translate value="Lv4" />
            </label>
            <label style={styles.section}>
              <Input {...input} type="radio" value="5" checked={input.value === 5 || input.value === '5' } /><Translate value="Lv5" />
            </label>
        </div>
      </div>
    );
  }
}

const styles = {
    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: '16px',
    },
    booleanInput: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
    },
    section: {
        marginLeft: '20px',
        minWidth: '36px',
    },
}



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/LevelView.jsx